module.exports = __webpack_public_path__ + "static/team-header-small.9b11f08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-header-small.jpg
// module id = 113
// module chunks = 137408898365125 176236309070072